import { useEffect, useState } from "react";
import { Cell, Group, Header } from "@vkontakte/vkui";
import { api, errorMessage } from "../api/client";
import { formatMoney } from "../shared/format";
import { Page } from "../components/Page";
import { EmptyState, ErrorState, LoadingState } from "../components/States";

type Leader = {
  place: number;
  fullName: string;
  level: string;
  totalSaved: number;
};

export function LeaderboardPage() {
  const [leaders, setLeaders] = useState<Leader[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    api
      .get<{ leaders: Leader[] }>("/leaderboard")
      .then((response) => {
        setLeaders(response.data.leaders);
        setError("");
      })
      .catch((err) => setError(errorMessage(err)))
      .finally(() => setLoading(false));
  }, []);

  return (
    <Page title="Рекордсмены">
      {loading ? <LoadingState /> : null}
      {error ? <ErrorState message={error} /> : null}
      {!loading && !error && leaders.length === 0 ? <EmptyState text="Пока нет участников для таблицы." /> : null}
      <Group header={<Header>Экономия членов клуба</Header>}>
        {leaders.map((leader) => (
          <Cell key={`${leader.place}-${leader.fullName}`} subtitle={leader.level} before={`#${leader.place}`} after={formatMoney(leader.totalSaved)}>
            {leader.fullName}
          </Cell>
        ))}
      </Group>
    </Page>
  );
}
